export default [
  {
    path: '/real-estate-developments',
    name: 'RealEstateDevelopmentsList',
    component: () => import('pages/real-estate-developments/RealEstateDevelopmentsList.vue')
  },
  {
    path: '/real-estate-developments/new',
    name: 'RealEstateDevelopmentsCreate',
    component: () => import('pages/real-estate-developments/form/RealEstateDevelopmentsForm.vue')
  }
]
